import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Heading from '@/components/atoms/Heading';
import useStagger from '@/hooks/animations/use-stagger';
import * as React from 'react';
import ArticleGroupResultCard from '../ArticleGroupResultCard';
import NoListingResults from '../NoListingResults';
const ArticleGroupListingGrid = ({ items = [], noResultsTitle, noResultsText, }) => {
    const containerRef = React.useRef(null);
    useStagger(containerRef, {
        childrenStaggerFrom: 'start',
    });
    const groupedItems = items.reduce((acc, item) => {
        let group = acc.find((group) => group.year === item.dataObject.year);
        if (!group) {
            group = {
                year: item.dataObject.year,
                items: [],
            };
            acc.push(group);
        }
        group.items.push(item);
        return acc;
    }, []);
    if (items.length === 0) {
        return _jsx(NoListingResults, { title: noResultsTitle, text: noResultsText });
    }
    return (_jsx("div", { ref: containerRef, className: "grid-base grid-cols-12 gap-1.5 md:gap-2.5", "data-show-after-hydration": true, children: groupedItems.map((group) => {
            return (_jsxs(React.Fragment, { children: [_jsx(Heading, { as: "h2", variant: "ex-lg", className: "col-span-12 md:type-expressive-md md:col-span-4 lg:col-span-3", children: group.year }), group.items.map((item, index) => (_jsx("div", { className: "col-span-12 md:col-span-8 md:col-start-5 lg:col-span-9 lg:col-start-4", children: _jsx(ArticleGroupResultCard, { card: item.dataObject }) }, `${item.dataObject.componentID}${index}${group.year}`)))] }, group.year));
        }) }));
};
export default ArticleGroupListingGrid;
